import { takeEvery, call } from 'redux-saga/effects'
import { trackEvent } from '@offerzen/pinata-shame'

import * as analyticsView from '../reducks/analytics'
import { errorHandler } from '../helpers/errorHelpers'

function* trackEventSaga({ meta }) {
  try {
    yield call(trackEvent, meta.name, meta.data)
  } catch (err) {
    yield call(errorHandler, err)
  }
}

export default function* watchAnalyticsSagas() {
  yield takeEvery(analyticsView.TRACK_EVENT, trackEventSaga)
}
